import axiosInstance from '@/api/axios'


// 获取消息列表
export function getMessageTypeListApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/push/message/userTypeList',
        method: 'post',
        data: parameter,
    })
}

//置为已读
export function readApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/push/message/updateAsRead',
        method: 'post',
        data: parameter,
    })
}

//二级页面的消息列表
export function getMessageListApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/push/message/list',
        method: 'post',
        data: parameter,
    })
}
